import {dateDaysAgo, daysBetweenDates, formatDateNoTime} from "../../utils/friendlyDate";
import {Slider, SliderSingleProps} from "antd";

export interface DateRangeSelectorProps {
    min: Date;
    max: Date;
    from: Date;
    to: Date;
    onChange: (values: Date[]) => void;
}

const DateRangeSelector = ({ min, max = new Date(), from, to, onChange }: DateRangeSelectorProps) => {
    const maxRange = daysBetweenDates(min.toString(), max.toString());
    const formatter = (value: number | undefined) => `${value!==undefined ? formatDateNoTime(dateDaysAgo(maxRange-value)) : '-'}`;
    const toIndex = maxRange - daysBetweenDates(to.toString(), max.toString());
    const fromIndex = toIndex - daysBetweenDates(from.toString(), to.toString());

    const onDragDrop = (indexes: number[]) => {
        const date1 = dateDaysAgo(maxRange - indexes[0], max);
        const date2 = dateDaysAgo(maxRange - indexes[1], max);
        onChange([date1, date2]);
    }

    return (
        <Slider range min={0} max={maxRange} defaultValue={[fromIndex, toIndex]} tooltip={{ formatter }} onChange={onDragDrop} />
    );
}

export default DateRangeSelector;